import {secretApi} from "./api";
import {sortChampData} from "../function";


// https://b2c-api-cdn.deeplol.gg/champion/mastery_rank?platform_id=All&lane=All&champion_id=41&cnt=100
export const championMasteryAPI = async ({platform_id, champion_id, lane}) => {
    const url = new URL(`${process.env.REACT_APP_CACHE_API}champion/mastery_rank`);
    url.searchParams.set('platform_id', platform_id);
    url.searchParams.set('lane', lane);
    url.searchParams.set('champion_id', champion_id);
    url.searchParams.set('cnt', '100');

    const result = await secretApi.get(url.toString());
    const list = result?.data?.data_list;

    if (!Array.isArray(list)) {
        throw new Error("championMastery: check data type");
    }

    return sortChampData(list, [{value: 'rank', sortType: true}]);
}
